import React from "react";
import Slider from "./slieder";
import { motion } from "framer-motion";
import FooterwithoutLogin from "./footerwithoutLogin";
import SEO from "../SEO/seo";

function GrowBags() {
  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 },
  };

  const scaleFade = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: { opacity: 1, scale: 1 },
  };

  const imageZoom = {
    hidden: { scale: 1.05, opacity: 0 },
    visible: { scale: 1, opacity: 1 },
  };

  const slideLeftToRight = {
    hidden: { opacity: 0, x: -100 },
    visible: { opacity: 1, x: 0 },
  };

  const slideRightT0Left = {
    hidden: { opacity: 0, x: 100 },
    visible: { opacity: 1, x: 0 },
  };

  return (
    <>
      <SEO
        title="Growbags Hydroponic | Kryzen Grow Bag Farming Systems"
        description="Hydroponic Grow Bags use inert media like coco coir or perlite to grow plants without soil. Nutrient-rich water is delivered via drip irrigation, making it ideal for efficient, scalable farming systems."
        keywords="growbags hydroponic, hydroponic grow bags, cocopeat farming, drip irrigation hydroponics, soil-free farming, kryzen hydroponic system, grow bag farming, hydroponics with coco coir"
        canonical="https://alpha.kryzen.com/kryzen-for-soil-less-growing"
        ogTitle="Growbags Hydroponic | Kryzen Grow Bag Farming Systems"
        ogDescription="Kryzen's Hydroponic Grow Bag systems use cocopeat, perlite, or vermiculite for soil-free cultivation. A perfect solution for nutrient delivery through drip irrigation and high-efficiency farming."
        ogImage="https://res.cloudinary.com/bsgfcooa/image/upload/v1752295792/kryzen-page-1_mxs1q5.jpg"
        twitterTitle="Growbags Hydroponic | Kryzen Grow Bag Farming Systems"
        twitterDescription="Hydroponic Grow Bags filled with coco coir or perlite provide an efficient, scalable, and soil-free farming solution with precise nutrient delivery through drip irrigation."
      />
      <div>
        <Slider
          heding={"soil-less growing"}
          paragraph={
            "Kryzen Services specializes in soilless farming solutions, providing cutting-edge technologies like hydroponics, aquaponics, and aeroponics to farmers looking to grow crops without soil. These methods offer efficient use of water and nutrients, higher crop yields, and the ability to grow plants in non-arable spaces."
          }
        ></Slider>
        <div className="container mainDiv py-5">
          <div className="text-center py-5 px-3">
            <motion.h1
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={fadeUp}
              transition={{ duration: 0.7 }}
              className="display-md-4 display-lg-4 display-5 fw-bold text-uppercase text-success mb-2"
            >
              kryzen growbags hydroponic
            </motion.h1>

            <hr></hr>
            <motion.p
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={fadeUp}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="lead mx-auto p-5"
              style={{ lineHeight: "1.8", fontSize: "25px" }}
            >
              Hydroponics Grow Bags are a variation of traditional hydroponic
              systems where plants are grown in special bags filled with an
              inert growing medium, such as coco coir, perlite, or vermiculite,
              rather than soil. In this setup, nutrient-rich water is supplied
              to the plants through drip irrigation or other hydroponic methods,
              allowing the roots to absorb essential nutrients directly from the
              solution.
            </motion.p>
          </div>
          <div className="row g-5 align-items-stretch mt-7">
            {/* Left Column */}
            <div className="col-md-4">
              <motion.div
                className="card border-0 h-100"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
                variants={slideLeftToRight}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <motion.img
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: false, amount: 0.3 }}
                  variants={imageZoom}
                  transition={{ duration: 0.6 }}
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752147218/mainframe_totggg.jpg"
                  alt="What is a Polyhouse?"
                  className="card-img-top img-fluid"
                  style={{ width: "100%", height: "300px" }}
                />
                <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    Main Frame Material
                  </h5>
                  <motion.p
                    className="card-text text-secondary"
                    style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={fadeUp}
                    transition={{ duration: 0.6, delay: 0.2 }}
                  >
                    Constructed from high-quality hot-dip galvanized steel, our
                    structure boasts a Zinc-coating of 275g/m2, ensuring a
                    robust service life of over 20 years. The steel components
                    are assembled on-site without needing secondary processing.
                    Galvanized connectors and fasteners are designed to resist
                    rust for two decades, guaranteeing long-term durability and
                    reliability.
                  </motion.p>
                </div>
              </motion.div>
            </div>

            <div className="col-md-4">
              <motion.div
                className="card border-0 h-100"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
                variants={scaleFade}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <motion.img
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: false, amount: 0.3 }}
                  variants={imageZoom}
                  transition={{ duration: 0.6 }}
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752147339/out_ddbqic.webp"
                  alt="Grrenhouse Benefits"
                  className="card-img-top img-fluid p-2"
                  style={{ width: "100%", height: "300px" }}
                />
                <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    Covering Materials
                  </h5>
                  <motion.p
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={fadeUp}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className="card-text text-secondary"
                    style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                  >
                    Our covering materials made up of LDPE, mLLDPE, EVA, EBA
                    with a tensile strength of 25 MPa offer excellent light
                    transmission, superior heat preservation, and strong tensile
                    strength. They provide economical rain, wind & sun
                    protection to plants, with a lifespan of 5-7 years, ensuring
                    cost-effectiveness without compromising on quality.
                  </motion.p>
                </div>
              </motion.div>
            </div>

            {/* Right Column */}
            <div className="col-md-4">
              <motion.div
                className="card border-0 h-100"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
                variants={slideRightT0Left}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <motion.img
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: false, amount: 0.3 }}
                  variants={imageZoom}
                  transition={{ duration: 0.6 }}
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752147630/nvph_knv1je.webp"
                  alt="Grrenhouse Benefits"
                  className="card-img-top img-fluid p-2"
                  style={{ width: "100%", height: "300px" }}
                />
                <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    Outside Shading System
                  </h5>
                  <motion.p
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={fadeUp}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className="card-text text-secondary"
                    style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                  >
                    Engineered to provide optimal cooling and shading during the
                    summer, this system diffuses sunlight within the greenhouse,
                    effectively shielding crops from harmful sun glare and
                    ensuring consistent growth conditions. Shading systems are
                    utilized widely when you want to grow crops which are
                    locally climatically affected.
                  </motion.p>
                </div>
              </motion.div>
            </div>
          </div>
          <div>
            <div
              className="container  py-5 mt-7"
              style={{
                background:
                  "color-mix(in srgb,rgb(204, 255, 204) 15%, transparent)",
                color: "#000",
                border: "1px solid #c0e6b6",
                borderRadius: "8px",
                padding: "1rem",
              }}
            >
              <div className="table-responsive">
                <table className="table table-bordered table-striped align-middle">
                  <thead className="table-success">
                    <tr>
                      <th style={{ width: "25%" }}>Features</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">Cost-Effective</th>
                      <td>
                        Hydroponic grow bags are typically more affordable than
                        traditional hydroponic systems that require complex
                        equipment like pipes, channels, or reservoirs. They are
                        also reusable, making them cost-efficient in the long
                        term.
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Space-Efficient</th>
                      <td>
                        Grow bags can be used in both indoor and outdoor setups,
                        making them suitable for small spaces such as balconies,
                        rooftops, or urban farms. They can be placed on the
                        ground, in racks, or hung vertically to maximize growing
                        space.
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Space-Efficient</th>
                      <td>
                        NFT systems can be set up in tight spaces, making them
                        ideal for urban or indoor farming. Flat bed systems can
                        also be expanded or stacked vertically for even more
                        efficiency.
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Improved Root Aeration</th>
                      <td>
                        The breathable material of fabric grow bags improves air
                        circulation around the roots, which helps prevent root
                        diseases and encourages healthy, vigorous growth.
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Sustainability</th>
                      <td>
                        Grow bags often require less water than traditional
                        soil-based growing, and the water is used more
                        efficiently in hydroponic systems. Additionally, they
                        often use sustainable growing media like coco coir.
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Scalable</th>
                      <td>
                        This system is scalable, from small home gardening
                        setups to large commercial operations. You can start
                        small and easily expand by adding more grow bags as
                        needed.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="text-center py-5 px-3">
            <motion.h1
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={fadeUp}
              transition={{ duration: 0.7 }}
              className="display-md-4 display-lg-4 display-6 fw-bold text-uppercase mt-7"
            >
              Product Parameters
            </motion.h1>

            <hr></hr>
          </div>
          <div
            className=" py-5"
            style={{
              background:
                "color-mix(in srgb,rgb(255, 208, 143) 10%, transparent)",
              color: "black",
              border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
              padding: "1rem",
              borderRadius: "0.25rem",
            }}
          >
            <div className="row">
              <div className="col-12">
                <h3 className="text-success fw-bold mb-4">
                  Technical Specifications
                </h3>
                <div className="table-responsive">
                  <table className="table table-bordered align-middle">
                    <tbody>
                      <tr>
                        <th scope="row">Wind Load</th>
                        <td>0.5 KN/m²</td>
                      </tr>
                      <tr>
                        <th scope="row">Snow Load</th>
                        <td>0.35 KN/m²</td>
                      </tr>
                      <tr>
                        <th scope="row">Maximum Drainage Capacity</th>
                        <td>140 mm/h</td>
                      </tr>
                      <tr>
                        <th scope="row">Span Width</th>
                        <td>4m, 8m, 9.6m, 10.8m, 12.8m or customized</td>
                      </tr>
                      <tr>
                        <th scope="row">Column Spacing</th>
                        <td>4.0m, 8.0m or customized</td>
                      </tr>
                      <tr>
                        <th scope="row">Shoulder Height</th>
                        <td>3.0m – 6.0m or customized</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="col-12 mt-5">
                <p
                  style={{
                    fontSize: "1.05rem",
                    lineHeight: "1.8",
                    color: "#444",
                  }}
                >
                  Plastic film Polytunnel is a simple type of protected
                  cultivation tunnelled greenhouse, which uses transparent
                  plastic films made of polymer materials such as polyethene and
                  polypropylene and connects each arch greenhouse into a whole
                  through the method of connecting wires and buildings. The
                  multi-span polytunnel or greenhouse connects the original
                  independent greenhouse with the original independent single
                  room model greenhouse through reasonable design, increasing
                  the insulation area of the greenhouse and improving its
                  performance
                </p>
              </div>
            </div>
          </div>

          <div className="row g-5 align-items-stretch mt-7">
            {/* Left Column */}
            <div className="col-md-4">
              <div
                className="card border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
              >
                <img
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752295792/46_uiu4om.jpg"
                  alt="COCOPEAT GROWBAGS"
                  className="card-img-top img-fluid p-2"
                  style={{ width: "100%", height: "280px" }}
                />
                <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    COCOPEAT GROWBAGS
                  </h5>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div
                className="card border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
              >
                <img
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752295792/kryzen-page-1_mxs1q5.jpg"
                  alt="COCOPEAT GROWSLABS"
                  className="card-img-top img-fluid p-2"
                  style={{ width: "100%", height: "280px" }}
                />
                <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    COCOPEAT GROWSLABS
                  </h5>
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div className="col-md-4">
              <div
                className="card border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
              >
                <img
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752295792/48_hsnqx0.jpg"
                  alt="ROCKWOOL GROWSLABS"
                  className="card-img-top img-fluid p-2"
                  style={{ width: "100%", height: "280px" }}
                />
                <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    ROCKWOOL GROWSLABS
                  </h5>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center py-5 px-3 mt-7">
            <motion.h1
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={fadeUp}
              transition={{ duration: 0.7 }}
              className="display-md-4 display-lg-4 display-6 fw-bold text-uppercase"
            >
              Optional Intelligent Polytunnel Add-ons
            </motion.h1>

            <hr></hr>
          </div>
          <div>
            <div
              className="container  py-5"
              style={{
                background:
                  "color-mix(in srgb,rgb(204, 255, 204) 15%, transparent)",
                color: "#000",
                border: "1px solid #c0e6b6",
                borderRadius: "8px",
                padding: "1rem",
              }}
            >
              <h3 className="text-success fw-bold mb-4">
                Optional Intelligent Polytunnel Add-ons
              </h3>

              <div className="table-responsive">
                <table className="table table-bordered table-striped align-middle">
                  <thead className="table-success">
                    <tr>
                      <th style={{ width: "25%" }}>Add-on</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">Steel Structure</th>
                      <td>Hot-galvanized steel pipe</td>
                    </tr>
                    <tr>
                      <th scope="row">Greenhouse Glass</th>
                      <td>Different models can be selected</td>
                    </tr>
                    <tr>
                      <th scope="row">Sun-shading Net</th>
                      <td>
                        Summer shade, block rain, moisture, cooling,
                        winter/spring heat preservation
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Cooling System</th>
                      <td>
                        The fan forms negative pressure and the water curtain
                        cools down
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Heating System</th>
                      <td>
                        Thermal insulation series, air heater, boiler and pipe
                        heating, air circulating fan
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Ventilation System</th>
                      <td>Side windows and cooling fans</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        Water & Fertilizer Integrated Irrigation System
                      </th>
                      <td>
                        Sprinkler irrigation series, drip irrigation series,
                        intelligent mobile sprinkler irrigation
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Automatic Control System</th>
                      <td>
                        Automatic control technology that can independently
                        drive intelligent machines to achieve control objectives
                        without human intervention
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Fill-in Light</th>
                      <td>
                        Easy assemble auto light deprivation blackout greenhouse
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Seedling Bed</th>
                      <td>Movable seeding bed</td>
                    </tr>
                    <tr>
                      <th scope="row">Hydroponics</th>
                      <td>
                        It is reusable, requires no nutrient additions, and is
                        both convenient and inexpensive.
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">External & Internal Shading System</th>
                      <td>The gear rack drives the shading system</td>
                    </tr>
                    <tr>
                      <th scope="row">Photovoltaic System</th>
                      <td>For solar power generation</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterwithoutLogin></FooterwithoutLogin>
    </>
  );
}

export default GrowBags;
